import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  width: 100vw;
  padding: 0.2rem 0.5rem;
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgb(255, 255, 255); /* Putih */
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 100px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const ContactWrapper = styled("div")<any>`
  cursor: pointer;
  width: ${(p) => (p.width ? "100%" : "110px")};
  font-weight: 700;
  text-align: center;
  border-radius: 1.25rem;
  display: inline-block;
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 1024px) {
    display: block;
  }

  display: none;

  svg {
    fill: #2e186a;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Menus = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 18px;
  color: #rgb(0, 0, 0);
  transition: color 0.2s ease-in;
  margin: 0.5rem 1.1rem;

  @media only screen and (max-width: 768px) {
    margin: 1rem 2rem;
    .menu-item {
      padding: 10px; /* Ubah nilai padding menjadi 10px untuk layar yang lebih kecil */
    }
  }

  @media only screen and (max-width: 1024px) {
    margin: 1rem 2rem;
    .menu-item {
      padding: 15px; /* Ubah nilai padding menjadi 15px untuk layar yang lebih besar */
    }
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)<any>`
  font-size: 20px;
`;

export const Span = styled("span")`
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease-in-out;
  gap: 5px;
  line-height: 1.2;
`;
